import { ApolloClient } from '@apollo/client'

import {
  CartDataInput,
  CartInfoDocument,
  CartInfoQueryResult,
  CheckProductsInStockDocument,
  InitialSyncCartsDocument,
  LoadCartsDocument,
  StockProductInput,
  SyncCartDocument,
} from '@shared/generated'

import { CartInfoRequestVariables } from '../hooks/useCartInfo'

type Cart = { shop_id: string; items: CartDataInput[] };

export class CartApi {
  constructor (private readonly client: ApolloClient<unknown>) {}

  async loadCarts () {
    return await this.client.query({
      query: LoadCartsDocument,
      fetchPolicy: 'no-cache',
    })
  }

  async syncCart (cart: Cart) {
    return await this.client.mutate({
      mutation: SyncCartDocument,
      variables: {
        cart,
      },
    })
  }

  async initialSyncCarts (carts: Cart[]) {
    return await this.client.mutate({
      mutation: InitialSyncCartsDocument,
      variables: {
        carts,
      },
    })
  }

  async checkProductsInStock (productData: StockProductInput) {
    return await this.client.query({
      query: CheckProductsInStockDocument,
      variables: {
        productData,
      },
      fetchPolicy: 'no-cache',
    })
  }

  async cartInfoData (infoDataVariables: CartInfoRequestVariables) {
    if (!infoDataVariables.cartInfo.items?.length) return null

    return (await this.client.query({
      query: CartInfoDocument,
      variables: infoDataVariables,
      fetchPolicy: 'no-cache',
    })) as CartInfoQueryResult
  }
}
